"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeletingSelector = exports.errorMessageSelector = exports.isEditComponentModalVisibleSelector = exports.componentToBeEditedSelector = exports.hasErrorSavingChangesSelector = exports.changesSavedSuccessSelector = exports.isComponentToastOpenSelector = exports.isSavingChangesSelector = exports.isComponentModalVisibleSelector = exports.isSavePromptVisibleSelector = exports.isDeleteAlertDialogOpen = exports.rowIndexToBeDeletedSelector = exports.componentToBeDeletedSelector = exports.isDeleteAlertDialogOpenSelector = exports.isComponentListLoadingSelector = exports.componentTableRowsSelector = void 0;
const componentTableRowsSelector = (state) => {
    return state.components.components;
};
exports.componentTableRowsSelector = componentTableRowsSelector;
const isComponentListLoadingSelector = (state) => {
    return state.components.isComponentListLoading;
};
exports.isComponentListLoadingSelector = isComponentListLoadingSelector;
const isDeleteAlertDialogOpenSelector = (state) => {
    return state.components.isDeleteAlertDialogOpen;
};
exports.isDeleteAlertDialogOpenSelector = isDeleteAlertDialogOpenSelector;
const componentToBeDeletedSelector = (state) => {
    return state.components.componentToBeDeleted;
};
exports.componentToBeDeletedSelector = componentToBeDeletedSelector;
const rowIndexToBeDeletedSelector = (state) => {
    return state.components.rowIndexToBeDeleted;
};
exports.rowIndexToBeDeletedSelector = rowIndexToBeDeletedSelector;
const isDeleteAlertDialogOpen = (state) => {
    return state.components.isDeleteAlertDialogOpen;
};
exports.isDeleteAlertDialogOpen = isDeleteAlertDialogOpen;
const isSavePromptVisibleSelector = (state) => {
    return state.components.isSavePromptVisible;
};
exports.isSavePromptVisibleSelector = isSavePromptVisibleSelector;
const isComponentModalVisibleSelector = (state) => {
    return state.components.isComponentModalVisible;
};
exports.isComponentModalVisibleSelector = isComponentModalVisibleSelector;
const isSavingChangesSelector = (state) => {
    return state.components.isSavingChanges;
};
exports.isSavingChangesSelector = isSavingChangesSelector;
const isComponentToastOpenSelector = (state) => {
    return state.components.isComponentToastOpen;
};
exports.isComponentToastOpenSelector = isComponentToastOpenSelector;
const changesSavedSuccessSelector = (state) => {
    return state.components.changesSavedSuccess;
};
exports.changesSavedSuccessSelector = changesSavedSuccessSelector;
const hasErrorSavingChangesSelector = (state) => {
    return state.components.hasErrorSavingChanges;
};
exports.hasErrorSavingChangesSelector = hasErrorSavingChangesSelector;
const componentToBeEditedSelector = (state) => {
    return state.components.componentToBeEdited;
};
exports.componentToBeEditedSelector = componentToBeEditedSelector;
const isEditComponentModalVisibleSelector = (state) => {
    return state.components.isEditComponentModalVisible;
};
exports.isEditComponentModalVisibleSelector = isEditComponentModalVisibleSelector;
const errorMessageSelector = (state) => {
    return state.components.errorMessage;
};
exports.errorMessageSelector = errorMessageSelector;
const isDeletingSelector = (state) => {
    return state.components.isDeleting;
};
exports.isDeletingSelector = isDeletingSelector;
